import Button from "../Button";
import { ChevronLeftIcon, ClientInCircleIcon, GearIcon } from "../fancyIcons";
import { Link, To } from "react-router-dom";
import FayTooltip from "../../FayTooltip";
import { useIdentity } from "../../../provider-portal/IdentityProvider";
import classNames from "classnames";
import { useChatImplementation } from "./providers/ChatProvider/useChatMigration";
import { useSelectedChatChannel } from "./providers/ChatProvider/SelectedChannel";

export interface ChatHeaderProps {
  respondentProfileLink?: To;
  respondentDisplayName: string;
  RespondentAvatar: () => React.ReactNode;
  showAutopilotSettings?: boolean;
}

type UseChatShim = {
  clearSelectedConversation: () => void;
};

const useChatShim = (): UseChatShim => {
  const { useApiChat } = useChatImplementation();
  const { clearSelectedChatChannel: clearSelectedConversation } =
    useSelectedChatChannel();

  return {
    clearSelectedConversation: useApiChat
      ? clearSelectedConversation
      : () => {},
  };
};

const ConversationHeader = ({
  RespondentAvatar,
  respondentProfileLink,
  respondentDisplayName,
  showAutopilotSettings,
}: ChatHeaderProps) => {
  const { isAdmin, isProvider, providerId } = useIdentity(); // eslint-disable-line @typescript-eslint/no-unused-vars
  const { clearSelectedConversation } = useChatShim();

  return (
    <div
      className={
        "tw-absolute tw-top-0 tw-z-10 tw-flex tw-w-full tw-justify-between tw-bg-white/75 tw-px-4 tw-pb-2 tw-pt-2 tw-shadow-sm tw-backdrop-blur-md md:tw-p-6"
      }
    >
      <Button
        type="default"
        to="../"
        onClick={() => {
          clearSelectedConversation();
        }}
        Icon={ChevronLeftIcon}
        data-testid="back-button"
        className="md:tw-hidden"
      />
      <div className={"tw-flex tw-items-center tw-gap-2 md:tw-gap-4"}>
        <RespondentAvatar />
        <div className="tw-font-bold">
          <span className="tw-hidden md:tw-inline">Conversation with </span>
          {respondentProfileLink ? (
            <Link
              to={respondentProfileLink}
              target={!isProvider ? "_blank" : undefined}
            >
              {respondentDisplayName}
            </Link>
          ) : (
            respondentDisplayName
          )}
        </div>
      </div>
      <div
        className={classNames(
          "md:tw-flex",
          !isProvider ? "tw-hidden" : "tw-flex tw-gap-4",
        )}
      >
        {showAutopilotSettings && (
          <>
            <Button
              to={"#"}
              type="default"
              className="tw-hidden tw-cursor-pointer tw-justify-self-end md:tw-flex"
              Icon={GearIcon}
              disabled
              data-tooltip-id="fay-tooltip"
            >
              Autopilot settings
            </Button>
            <Button
              to={"#"}
              type="default"
              className="tw-cursor-pointer tw-justify-self-end md:tw-hidden"
              Icon={GearIcon}
              disabled
              data-tooltip-id="fay-tooltip"
            />
            <FayTooltip>Coming soon</FayTooltip>
          </>
        )}
        {respondentProfileLink && (
          <>
            {isProvider && (
              <Button
                to={respondentProfileLink}
                target={!isProvider ? "_blank" : undefined}
                type="default"
                className="tw-justify-self-end md:tw-hidden"
                Icon={ClientInCircleIcon}
              />
            )}
            <Button
              to={respondentProfileLink}
              target={!isProvider ? "_blank" : undefined}
              type="default"
              className="tw-hidden tw-justify-self-end md:tw-flex"
              Icon={ClientInCircleIcon}
            >
              {isProvider ? "Client" : "Provider"} profile
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ConversationHeader;
